import { render, staticRenderFns } from "./SnowBoxes.vue?vue&type=template&id=98216450&"
import script from "./SnowBoxes.vue?vue&type=script&lang=ts&"
export * from "./SnowBoxes.vue?vue&type=script&lang=ts&"
import style0 from "./SnowBoxes.vue?vue&type=style&index=0&id=98216450&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports